import React, { Suspense } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import { AuthAppOutlet, EmployeePrivateRoute } from "@homesusa/auth";
import {
  ErrorBoundary,
  LogRocketTelemetry,
  mapRoutes,
  RoleEmployee
} from "@homesusa/core";
import {
  appPublicRoutesConfig,
  appPrivateRoutesConfig,
  LayoutPrivateRoute
} from "@homesusa/layout";
import { logRocketTelemetry } from "core/telemetry";
import UserDetail from "modules/users/pages/user-details.component";
import UserGrid from "modules/users/pages/user-grid.component";
import UserProfile from "modules/users/pages/user-profile.component";

const EmailConfirmed = React.lazy(
  () => import("modules/users/pages/email-confirmed.component")
);

function AppRoutes(): JSX.Element {
  return (
    <Suspense fallback={<LinearProgress />}>
      <Routes>
        <Route
          path="/"
          element={
            <AuthAppOutlet
              apiUrl={process.env.REACT_APP_API_COMPANY}
              useCookies={process.env.REACT_APP_USE_COOKIES !== "false"}
            />
          }
        >
          {mapRoutes(appPublicRoutesConfig)}
          <Route
            element={<LayoutPrivateRoute />}
            errorElement={<ErrorBoundary />}
          >
            <Route
              element={
                <LogRocketTelemetry telemetry={logRocketTelemetry}>
                  <Outlet />
                </LogRocketTelemetry>
              }
            >
              {mapRoutes(appPrivateRoutesConfig)}
              <Route
                element={
                  <EmployeePrivateRoute
                    allowedRoles={[RoleEmployee.CompanyAdmin]}
                  />
                }
              >
                <Route path="users/*">
                  <Route index element={<UserGrid />} />
                  <Route path=":id" element={<UserDetail />} />
                </Route>
              </Route>
              <Route path="profile" element={<UserProfile />} />
              <Route index element={<Navigate to={`/profile`} />} />
            </Route>
          </Route>
        </Route>
        <Route path="/confirmed-email" element={<EmailConfirmed />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
